import React, { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Renders an admin-protected image by fetching it as a blob with the admin
 * bearer token (plain <img src> cannot send Authorization headers).
 */
const AuthImage = ({ src, alt = '', className = '', testId }) => {
  const [url, setUrl] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoke = '';
    let active = true;
    setFailed(false);
    setUrl('');
    if (!src) return undefined;
    axios
      .get(src, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('adminToken')}` },
        responseType: 'blob',
      })
      .then((resp) => {
        if (!active) return;
        revoke = window.URL.createObjectURL(resp.data);
        setUrl(revoke);
      })
      .catch(() => active && setFailed(true));
    return () => {
      active = false;
      if (revoke) window.URL.revokeObjectURL(revoke);
    };
  }, [src]);

  if (failed || !src) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 text-gray-400 text-xs ${className}`} data-testid={testId}>
        No image
      </div>
    );
  }
  if (!url) {
    return <div className={`bg-gray-100 animate-pulse ${className}`} data-testid={testId} />;
  }
  return <img src={url} alt={alt} className={className} data-testid={testId} />;
};

export default AuthImage;
